<div class="general-terms-of-use">
  <div class="container-back">
        <app-back-button [title]="'module.generalTermsofUse.back' | translate" (backClicked)="goBack()">
        </app-back-button>
    </div>
    <div class="content">
        <iframe scrolling="no" [src]="anbDocumentLink"></iframe>
    </div>
</div>
